import { setLoading } from "../redux/app_global/reducer";
import { setLoading as setLoadingSurveys, setSurveys_id, setSurveys_list, setQuestions_id, setAnswers_id, setEmails_id, setCriteria_id, setPassing_id } from "../redux/surveys/reducer";
import Request, { RequestFile } from "./handler.js";

export const getSurveysSEO = async (data) => {
    var result = {};
    
    data.method = 'surveys_seo';

    await Request(data, 'post')
    .then(async json => {
        result = json;
    });

    return result;
}

export const getSurveysList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setSurveys_list(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const getSurveysId = async (data,dispatch,profile) => {
    var result = {};
    
    data.method = 'surveys_id';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {
        
        if (json?.code) {
            if (Object.keys(json?.result).length > 0) {
                json.result['error_code'] = 200;
                await dispatch(setSurveys_id(json?.result));
            } else {
                await dispatch(setSurveys_id({error_code:404}));
            }
        }

        result = json;
    });

    return result;
}

export const getSurveysQuestionsId = async (data,dispatch,profile) => {
    var result = {};
    
    data.method = 'surveys_questions_id';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setQuestions_id(json?.result));
        }

        result = json;
    });

    return result;
}

export const getSurveysQuestionsAnswersId = async (data,dispatch,profile) => {
    var result = {};
    
    data.method = 'surveys_questions_answers_id';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setAnswers_id(json?.result));
        }

        result = json;
    });

    return result;
}

export const getSurveysEmailsId = async (data,dispatch,profile) => {
    var result = {};
    
    data.method = 'surveys_emails_id';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setEmails_id(json?.result));
        }

        result = json;
    });

    return result;
}

export const getSurveysCriteriaId = async (data,dispatch,profile) => {
    var result = {};
    
    data.method = 'surveys_criteria_id';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setCriteria_id(json?.result));
        }

        result = json;
    });

    return result;
}

export const addSurveys = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const addSurveysQuestions = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_questions_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const addSurveysQuestionsAnswers = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_questions_answers_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const addSurveysEmails = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_emails_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const addSurveysCriteria = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_сriteria_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const updSurveysData = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_upd_data';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const updSurveysSeo = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_upd_seo';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const updSurveysContent = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_upd_content';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const updSurveysQuestions = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_questions_upd';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const updSurveysQuestionsAnswers = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_questions_answers_upd';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const updSurveysEmails = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_emails_upd';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const updSurveysCriteria = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_upd_criteria';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const delSurveysQuestions = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_questions_del';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const delSurveysQuestionsAnswers = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_questions_answers_del';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const delSurveysEmails = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_emails_del';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const delSurveysCriteria = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_criteria_del';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const delSurveysPhoto = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_del_photo';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const delSurveysPhotoBig = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_del_photo_big';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const addSurveysPassing = async (data,dispatch) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_passing_add';

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setPassing_id(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}

export const addSurveysPassingConsult = async (data,dispatch) => {
    var result = {};
    
    await dispatch(setLoadingSurveys(true));
    data.method = 'surveys_passing_consult';

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //
        }
        
        result = json;
    });
    await dispatch(setLoadingSurveys(false));

    return result;
}